define(function (require) {
	const tpl = require('../templates/t_cpv_card_menu.hbs');
	const itemView = require('./v_itv_menu_item');
	const IPSCollection = require('civicsBase/ipsModelCollection');

	return Marionette.CompositeView.extend({
		childEvents:{
			'actionItemClicked':'actionItemClicked'
		},
		childView: itemView,
		childViewContainer: ".menu-list",
		template: tpl,

		initialize: function (options) {
			this.config = options;

			this.collection = new IPSCollection(options.menu);
		},
		actionItemClicked:function(cardView,optionValue){
			//console.log('cpv option clicked');
			//trigger a method on the parent LOV
			this.triggerMethod('actionItemClicked', optionValue);
		}
	});
});
